import { z } from 'zod'
import { objectToCamel } from 'ts-case-convert'
import { FabricOrderStatus } from '../../constants'
import { addressSchema } from './address'
import { fabricSchema } from './fabric'
import * as GarmentSchemas from './garment' // to avoid circular dependency with garment schemas
import * as ShipmentSchemas from './shipment' // to avoid circular dependency with shipment schemas

//* ---------------- BASE ---------------- *//
const baseFabricOrderSchema = z.object({
  id: z.number(),
  fabric_id: z.number(),
  garment_id: z.number().nullable(),
  length: z.coerce.number(),
  address_id: z.number(),
  extra_fabric: z.boolean(),
  fulfillment_failure: z.boolean(),
  shipment_id: z.number().nullable(),
  reason: z.string().nullable(),
  created_at: z.coerce.date(),
  status: z.enum(FabricOrderStatus.VALID),
  trinity_fabric_number: z.string(),
  supplier_fabric_number: z.string(),
  description: z.string(),
  image: z.string().url(),
  material_type: z.string(),
  manufacturer_description: z.string(),
  fabric_composition: z.string(),
  fabric_weight: z.coerce.number(),
  fabric_price: z.coerce.number(),
  bolt_order: z.boolean(),
  dealer: z
    .object({
      name: z.string().nullable(),
      state: z.string().nullable(),
    })
    .optional(),
})

//* ---------------- SCHEMAS ---------------- *//
export const fabricOrderSchema = baseFabricOrderSchema.transform(objectToCamel)

export const extendedFabricOrderSchema = baseFabricOrderSchema
  .extend({
    fabric_composition: z.string(),
    fabric: fabricSchema,
    address: addressSchema,
    garment: z.lazy(() => GarmentSchemas.garmentSchema).nullable(),
    shipment: z.lazy(() => ShipmentSchemas.shipmentSchema).nullable(),
  })
  .transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  namespace TrinityAPI {
    type FabricOrderType = z.infer<typeof fabricOrderSchema>
    type FabricOrderExtendedType = z.infer<typeof extendedFabricOrderSchema>
  }
}
